module.exports = __webpack_public_path__ + "static/media/circle-xmark-solid.de03b868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circle-xmark-solid.svg
// module id = 274
// module chunks = 0